import { apiAuth as api } from "./index";

export interface LeadOrigin {
  uuid: string;
  id: number;
  name: string;
}

export interface LeadSeller {
  uuid: string;
  id: number;
  phone: string;
  user_id: number;
  user: {
    uuid: string;
    id: number;
    name: string;
    email: string;
    user_type_id: number;
  };
}

export interface Lead {
  id: number;
  uuid: string;
  name: string;
  email: string;
  phone: string;
  document: string;
  client_origin_id: number;
  seller_id: number;
  lead_step_id: number;
  lost_reason: string | null;
  notes: string;
  observation: string;
  converted_client_id: number | null;
  tenant_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  client_origin: LeadOrigin;
  lead_status: any;
  seller: LeadSeller;
  step_name?: string;
}

export interface ApiResponse<T> {
  status: boolean;
  response: {
    current_page: number;
    data: T[];
    first_page_url: string;
    from: number;
    last_page: number;
    last_page_url: string;
    links: {
      url: string | null;
      label: string;
      active: boolean;
    }[];
    next_page_url: string | null;
    path: string;
    per_page: number;
    prev_page_url: string | null;
    to: number;
    total: number;
  };
  message: string;
}

export interface LeadStep {
  uuid: string;
  id: number;
  name: string;
  tenant_id: number;
}

export async function getLeads(seller_id ?: number) {
  const { data } = await api.get<ApiResponse<Lead>>("/leads", {
    params: {
      seller_id: seller_id || ""
    }
  });
  
  const leadsWithStepName = data.response.data.map(lead => ({
    ...lead,
    step_name: lead.lead_status?.name || `Step ${lead.lead_step_id}`
  }));
  
  return {
    ...data,
    response: {
      ...data.response,
      data: leadsWithStepName
    }
  };
}

export async function getLead(uuid: string) {
  const { data } = await api.get<{ status: boolean; response: Lead; message: string }>(`/leads/${uuid}/show`);
  return data;
}

export async function createLead(lead: Partial<Lead>) {
  const { data } = await api.post("/leads/store", lead);
  return data;
}

export async function updateLead(uuid: string, lead: any) {
  const { data } = await api.put(`/leads/${uuid}/update`, lead);
  return data;
}

export async function deleteLead(uuid: string) {
  const { data } = await api.delete(`/leads/${uuid}/destroy`);
  return data;
}

export async function getLeadSelect() {
  const { data } = await api.get("/leads/select");
  return data;
}

export async function updateLeadStatus(uuid: string, lead_step_id: number) {
  const { data } = await api.put(`/leads/${uuid}/update-step`, { lead_step_id });
  return data;
}

export async function getLeadConversions() {
  const { data } = await api.get("/leads/conversions");
  return data;
} 